import { Link } from "react-router-dom";
import { NAV } from "./Header";
import { NewsletterForm } from "./NewsletterForm";
import { FitWordmark } from "./FitWordmark";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-dano-ink text-dano-cream grain">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-20 sm:pt-28 pb-10">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <p className="font-cond text-sm uppercase tracking-[0.22em] text-dano-red">The launch list</p>
          <h3 className="mt-4 font-wide text-3xl sm:text-4xl lg:text-5xl uppercase leading-[0.95]">Be first to taste the first batch.</h3>
          <p className="mt-4 max-w-md text-dano-cream/75">One email when bars are ready. No spam.</p>
          <div className="mt-8 max-w-lg">
            <NewsletterForm source="footer" tone="dark" id="footer-newsletter" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-8 lg:col-span-5 lg:col-start-8">
          <div>
            <p className="font-cond text-sm uppercase tracking-[0.22em] text-dano-cream/70">Explore</p>
            <ul className="mt-4 space-y-2">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} data-testid={`footer-link-${n.id}`} className="footer-link text-lg">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-cond text-sm uppercase tracking-[0.22em] text-dano-cream/70">Made from</p>
            <ul className="mt-4 space-y-2 text-lg text-dano-cream/85">
              <li>Oats</li><li>Nut butters</li><li>Dates</li><li>Honey</li><li>Quality protein</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-20 sm:mt-28 select-none text-dano-cream">
        <FitWordmark />
      </div>
      <div className="mt-8 flex flex-col gap-3 border-t border-dano-cream/15 pt-6 text-sm text-dano-cream/70 sm:flex-row sm:justify-between">
        <p>© 2026 DanoBars™ · danobars.com</p>
        <p data-testid="footer-tagline" className="font-cond uppercase tracking-[0.2em] text-dano-red">Dano Bars. More Than a Snack. Real Food. Real Flavor.</p>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-dano-cream">Admin</Link>
      </div>
    </div>
  </footer>
);
